import { defineComponent as _defineComponent } from 'vue'
import ProfileBlock from '@/features/user-profile/components/ProfileBlock.vue';
import InfiniteScroll from '@/components/list/InfiniteScroll.vue';

import PosterStack from '@/features/user-profile/components/PosterStack.vue';

import { useUserProfile } from '@/features/user-profile/composables/useUserProfile';
import { getArticleSlug } from '@/features/editorial/helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserArticles',
  setup(__props) {

function stripTags(htmlString: string): string {
	return htmlString.replace(/<\/?[a-zA-Z][^>]*?>/g, '');
}

const { articles, loadNextArticles, isAtEndOfArticles, isLoading } = useUserProfile();

return { __sfc: true,stripTags, articles, loadNextArticles, isAtEndOfArticles, isLoading, ProfileBlock, InfiniteScroll, PosterStack, getArticleSlug }
}

})